import { render, staticRenderFns } from "./FollowList.vue?vue&type=template&id=bb9aef66&scoped=true"
import script from "./FollowList.vue?vue&type=script&lang=js"
export * from "./FollowList.vue?vue&type=script&lang=js"
import style0 from "./FollowList.vue?vue&type=style&index=0&id=bb9aef66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9aef66",
  null
  
)

export default component.exports